import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/store'

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || 'https://api-test.yezza.io/'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    let user =  Cookies.get('user')
    if (user) {
      user = JSON.parse(user)
    } else {
      user = store.state.user.user
    }

    if (user) {
      config.headers['Authorization'] = `Token ${user.token}`
    }

    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    },
  })
}

const _axios_feedback_api = axios.create({
  baseURL: process.env.VUE_APP_FEEDBACK_API_URL
})

_axios_feedback_api.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    let user =  Cookies.get('feedback_api_user')
    if (user) {
      user = JSON.parse(user)
    } else {
      user = store.state.user.user
    }

    if (user) {
      config.params = {...config.params, access_token: user.token}
    }

    // const token = 'abcde'
    // config.params = {...config.params, access_token: token}
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios_feedback_api.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

Vue.use(Plugin)
Vue.prototype.$feedbackApi = _axios_feedback_api
export default Plugin
